(function () {
  var d = document, html = d.documentElement, C = window.cac || { routes: {} };
  var R = C.routes || {};
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var SVG = function (p) { return '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + p + '</svg>'; };
  var ICON = { minus: SVG('<path d="M5 12h14"/>'), plus: SVG('<path d="M5 12h14"/><path d="M12 5v14"/>') };

  function money(cents) {
    var f = C.money || '${{amount}}';
    function fmt(n, dec, ts, ds) {
      var p = (n / 100).toFixed(dec).split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (p[1] ? ds + p[1] : '');
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2, ',', '.');
      }
    });
  }

  /* color mode */
  function syncTheme() {
    var t = html.getAttribute('data-theme') || 'dark';
    $$('[data-theme-label]').forEach(function (el) { el.textContent = t === 'dark' ? el.getAttribute('data-to-light') : el.getAttribute('data-to-dark'); });
  }
  syncTheme();

  /* overlays */
  var lastFocus = null;
  function openOverlay(id) {
    var el = d.getElementById(id); if (!el) return;
    lastFocus = d.activeElement;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); html.classList.add('no-scroll');
    var f = $('[data-autofocus]', el) || $('button,a,input', el);
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeOverlay(el) {
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    if (!$('.overlay.is-open')) html.classList.remove('no-scroll');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') $$('.overlay.is-open').forEach(closeOverlay); });

  d.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-theme-toggle]'))) {
      e.preventDefault();
      var n = html.getAttribute('data-theme') === 'light' ? 'dark' : 'light';
      html.setAttribute('data-theme', n);
      try { localStorage.setItem('cac-theme', n); } catch (_) {}
      syncTheme(); return;
    }
    if ((t = e.target.closest('[data-open]'))) {
      var id = t.getAttribute('data-open');
      if (!d.getElementById(id)) return;
      e.preventDefault();
      $$('.overlay.is-open').forEach(function (o) { if (o.id !== id) closeOverlay(o); });
      if (id === 'cart-drawer') refreshCart().then(function () { openOverlay(id); });
      else openOverlay(id);
      return;
    }
    if ((t = e.target.closest('[data-close]'))) {
      var o = t.closest('.overlay'); if (o) { e.preventDefault(); closeOverlay(o); } return;
    }
    if ((t = e.target.closest('[data-thumb]'))) {
      var root = t.closest('[data-product]'), i = t.getAttribute('data-thumb');
      $$('[data-slide]', root).forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-slide') === i); });
      $$('[data-thumb]', root).forEach(function (b) { b.classList.toggle('is-active', b === t); });
      return;
    }
    if ((t = e.target.closest('[data-qty-btn]'))) {
      var w = t.closest('[data-qty]'), inp = $('input', w), v = parseInt(inp.value, 10) || 1;
      v += parseInt(t.getAttribute('data-qty-btn'), 10);
      inp.value = Math.max(parseInt(inp.getAttribute('min') || '1', 10), v);
      inp.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    if ((t = e.target.closest('[data-line-change]'))) {
      e.preventDefault();
      changeLine(parseInt(t.getAttribute('data-line'), 10), parseInt(t.getAttribute('data-line-change'), 10));
    }
  });

  /* cart */
  var drawer = d.getElementById('cart-drawer');
  function isPre(it) {
    if (/pre-?\s?order/i.test(it.product_title || '')) return true;
    var p = it.properties || {};
    for (var k in p) { if (/pre-?order/i.test(k)) return true; }
    return false;
  }
  function imgUrl(u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function renderCart(cart) {
    if (!cart) return;
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = !cart.item_count; });
    if (!drawer) return;
    $('[data-cart-count-label]', drawer).textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    $('[data-cart-empty]', drawer).hidden = cart.item_count > 0;
    $('[data-cart-foot]', drawer).hidden = !cart.item_count;
    var pre = 0, stock = 0;
    $('[data-cart-lines]', drawer).innerHTML = cart.items.map(function (it, i) {
      var p = isPre(it); if (p) pre++; else stock++;
      var line = i + 1;
      return '<div class="cline">' +
        '<a class="cline__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(imgUrl(it.image, 200)) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="cline__b">' +
          '<a class="cline__t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
          (it.variant_title && !it.product_has_only_default_variant ? '<span class="muted small">' + esc(it.variant_title) + '</span>' : '') +
          (p ? '<span class="label accent">Pre-order</span>' : '') +
          '<div class="cline__row"><div class="stepper stepper--sm">' +
            '<button type="button" class="ibtn ibtn--sm" data-line="' + line + '" data-line-change="' + (it.quantity - 1) + '" aria-label="Decrease">' + ICON.minus + '</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" class="ibtn ibtn--sm" data-line="' + line + '" data-line-change="' + (it.quantity + 1) + '" aria-label="Increase">' + ICON.plus + '</button>' +
          '</div><span class="cline__p">' + money(it.final_line_price) + '</span></div>' +
          '<button type="button" class="cline__rm" data-line="' + line + '" data-line-change="0">Remove</button>' +
        '</div></div>';
    }).join('');
    $('[data-cart-mixed]', drawer).hidden = !(pre && stock);
    $('[data-cart-subtotal]', drawer).innerHTML = money(cart.total_price);
  }
  function refreshCart() {
    return fetch(R.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; })
      .catch(function () {});
  }
  function changeLine(line, qty) {
    return fetch(R.cart_change + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  /* product */
  function syncAck(form) {
    var a = $('[data-ack]', form), b = $('[data-add]', form);
    if (b && !b.hasAttribute('data-unavailable')) b.disabled = !!(a && !a.checked);
  }
  $$('[data-product-form]').forEach(syncAck);
  d.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-ack]')) syncAck(t.form);
    if (t.matches('[data-variant-select]')) {
      var root = t.closest('[data-product]'), data = $('[data-variants]', root);
      if (!data) return;
      var variants = JSON.parse(data.textContent), v = null;
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === t.value) v = variants[i];
      if (!v) return;
      var pr = $('[data-price]', root);
      if (pr) pr.innerHTML = money(v.price) + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '');
      var b = $('[data-add]', root);
      if (v.available) { b.removeAttribute('data-unavailable'); b.textContent = b.getAttribute('data-label'); }
      else { b.setAttribute('data-unavailable', ''); b.textContent = 'Sold out'; b.disabled = true; }
      syncAck(t.form);
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (_) {}
      if (v.featured_media) {
        var th = $('[data-thumb][data-media-id="' + v.featured_media.id + '"]', root);
        if (th) th.click();
      }
    }
    if (t.matches('[data-sort]')) {
      var url = new URL(location.href);
      url.searchParams.set('sort_by', t.value); url.searchParams.delete('page');
      location.href = url.toString();
    }
  });
  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches('[data-product-form]')) return;
    var ack = $('[data-ack]', f);
    if (ack && !ack.checked) { e.preventDefault(); ack.focus(); return; }
    if (!drawer || C.cartType === 'page' || !window.fetch) return;
    e.preventDefault();
    var btn = $('[data-add]', f), err = $('[data-form-error]', f);
    btn.disabled = true; btn.classList.add('is-loading'); if (err) err.hidden = true;
    fetch(R.cart_add + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { if (err) { err.textContent = res.j.description || res.j.message || 'Could not add to cart.'; err.hidden = false; } return; }
        return refreshCart().then(function () { openOverlay('cart-drawer'); });
      })
      .catch(function () { f.submit(); })
      .then(function () { btn.classList.remove('is-loading'); btn.disabled = false; syncAck(f); });
  });

  /* predictive search */
  var pin = $('[data-predictive]'), pout = $('[data-predictive-results]'), plabel = $('[data-predictive-label]');
  if (pin && pout && R.predictive) {
    var pdef = pout.innerHTML, pdefLabel = plabel ? plabel.textContent : '', timer, seq = 0;
    pin.addEventListener('input', function () {
      clearTimeout(timer);
      var q = pin.value.trim();
      if (!q) { pout.innerHTML = pdef; if (plabel) plabel.textContent = pdefLabel; return; }
      timer = setTimeout(function () {
        var my = ++seq;
        fetch(R.predictive + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (j) {
            if (my !== seq) return;
            var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
            if (plabel) plabel.textContent = ps.length + (ps.length === 1 ? ' result' : ' results');
            pout.innerHTML = ps.map(function (p) {
              var img = (p.featured_image && p.featured_image.url) || p.image;
              var pre = /pre-?\s?order/i.test(p.title);
              var price = Math.round(parseFloat(p.price) * 100);
              return '<a class="pcard" href="' + esc(p.url) + '"><div class="pcard__media">' +
                (pre ? '<span class="pcard__badge"><span class="badge badge--accent">Preorder</span></span>' : (!p.available ? '<span class="pcard__badge"><span class="badge">Sold out</span></span>' : '')) +
                (img ? '<img class="pcard__img" src="' + esc(imgUrl(img, 500)) + '" alt="" loading="lazy">' : '') +
                '</div><div class="pcard__body"><span class="pcard__t">' + esc(p.title) + '</span><span class="pcard__p">' + (isNaN(price) ? '' : money(price)) + '</span></div></a>';
            }).join('');
          }).catch(function () {});
      }, 200);
    });
  }
})();
